<template>
  <v-card>
    <v-card-text class="pa-2">
      <div class="d-flex flex-wrap children-pa-2">
        <OCapCont label="Pausado?" class="w-1/2">
          <v-btn block :color="paused.color" @click="changeFlag('paused')">{{
            paused.label
          }}</v-btn>
        </OCapCont>

        <OCapCont label="Ignorado?" class="w-1/2">
          <v-btn block :color="ignored.color" @click="changeFlag('ignored')">{{
            ignored.label
          }}</v-btn>
        </OCapCont>

        <OCapCont label="Ponteiro do Receiver" class="w-full">
          <div class="d-flex w-full items-center">
            <span v-html="decHex(lastPointer)" />
            <v-spacer />
            <v-btn icon @click="changePointer">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
        </OCapCont>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import UnpauserStore from './UnpauserStore'
import brush from 'brush'
import { brNum } from 'oderon-commons/src/formatters'

export default {
  computed: {
    lastPointer() {
      return UnpauserStore.client.lastPointer
    },
    paused() {
      let value = UnpauserStore.client.isPaused
      let label = value ? 'SIM' : 'NÃO'
      let color = value ? 'amber' : ''
      return { value, label, color }
    },

    ignored() {
      let value = UnpauserStore.client.isIgnored
      let label = value ? 'SIM' : 'NÃO'
      let color = value ? 'error' : ''
      return { value, label, color }
    }
  },
  methods: {
    async changeFlag(flag) {
      let currValue = this[flag].value
      let desiredValue = !currValue

      let proceed = await this.$confirm({
        icon: 'od-warning',
        message: `Tem certeza que deseja alterar
          a flag <code>${flag}</code> para o valor
          <code>${desiredValue}</code>?`
      })

      if (proceed) {
        UnpauserStore.changeFlag(flag, desiredValue)
      }
    },

    async changePointer() {
      let currValue = this.lastPointer
      let desiredValue = await this.$prompt({
        label: 'Informe o ponteiro a partir do qual o Receiver irá pedir dados',
        decHex: true,
        value: currValue
      })

      if (desiredValue != null) {
        UnpauserStore.setRecvPointer(desiredValue)
      }
    },

    decHex(x) {
      if (x == null) return '─'
      return `${brNum(x)} <code>0x${brush.toHexString(x)}</code>`
    }
  }
}
</script>

<style></style>
